import React from "react";

const ExperienceCard = ({ role, company, period, description, achievements }) => {
  return React.createElement(
    "div",
    { style: styles.card },
    React.createElement(
      "div",
      { style: styles.header },
      React.createElement(
        "div",
        { style: styles.titleContainer },
        React.createElement(
          "h3",
          { style: styles.role },
          role
        ),
        React.createElement(
          "p",
          { style: styles.company },
          company
        )
      ),
      React.createElement(
        "p",
        { style: styles.period },
        period
      )
    ),
    React.createElement(
      "p",
      { style: styles.description },
      description
    ),
    achievements && achievements.length > 0 &&
      React.createElement(
        "ul",
        { style: styles.achievements },
        achievements.map((achievement, index) =>
          React.createElement(
            "li",
            { key: index, style: styles.achievement },
            achievement
          )
        )
      )
  );
};

const styles = {
  card: {
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    marginBottom: "20px",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
    flexWrap: "wrap",
  },
  titleContainer: {
    flex: "1",
  },
  role: {
    fontSize: "1.3rem",
    color: "#0077b6",
    marginBottom: "4px",
    fontWeight: "600",
  },
  company: {
    fontSize: "1rem",
    color: "#666",
    margin: "0",
    fontWeight: "500",
  },
  period: {
    fontSize: "0.9rem",
    color: "#888",
    margin: "0",
    fontStyle: "italic",
    whiteSpace: "nowrap",
  },
  description: {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.6",
    marginBottom: "12px",
  },
  achievements: {
    margin: "0",
    paddingLeft: "20px",
  },
  achievement: {
    fontSize: "0.95rem",
    color: "#666",
    lineHeight: "1.8",
    marginBottom: "6px",
  },
};

export default ExperienceCard;

